/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'help-classify': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M894.382 89.856H653.22c-53.965 0-103.808 23.89-137.784 65.787-33.972-41.897-83.82-65.787-137.785-65.787H136.32c-40.858 0-74.097 33.239-74.097 74.102v637.486c0 40.852 33.24 74.096 74.097 74.096h251.305c34.908 33.296 80.21 51.605 127.81 51.605s92.908-18.31 127.811-51.605h251.136c40.858 0 74.102-33.239 74.102-74.096V163.953c-.005-40.858-33.244-74.097-74.102-74.097zM596.178 810.148c-20.557 24.002-49.987 37.775-80.748 37.775-30.755 0-60.185-13.767-80.716-37.75a39.22 39.22 0 00-30.06-13.854H141.44V169.073h236.042c54.18 0 98.258 44.078 98.258 98.258v292.94c0 21.791 17.73 39.522 39.527 39.522s39.526-17.73 39.526-39.522V267.336c0-54.18 44.078-98.258 98.258-98.258h236.211v627.246h-263.05a39.168 39.168 0 00-30.034 13.824z"/>'
  }
})
